import React from 'react';
import PropTypes from 'prop-types';

const AspectRatioControls = ({ activeAspectRatio, setAspectRatio }) => {
  const setOneToOne = () => setAspectRatio('oneToOne');
  const setOneNineOneToOne = () => setAspectRatio('oneNineOneToOne');
  const setFourToThree = () => setAspectRatio('fourToThree');
  const setFree = () => setAspectRatio('free');

  return (
    <div className="btn-group mb2">
      <button
        className={`btn btn-sm ${
          activeAspectRatio === 'oneToOne' ? 'active' : ''
        }`}
        onClick={setOneToOne}
      >
        1:1
      </button>
      <button
        className={`btn btn-sm ${
          activeAspectRatio === 'oneNineOneToOne' ? 'active' : ''
        }`}
        onClick={setOneNineOneToOne}
      >
        1.91:1 (DV360 Specs)
      </button>
      <button
        className={`btn btn-sm ${
          activeAspectRatio === 'fourToThree' ? 'active' : ''
        }`}
        onClick={setFourToThree}
      >
        4:3
      </button>
      <button
        className={`btn btn-sm ${activeAspectRatio === 'free' ? 'active' : ''}`}
        onClick={setFree}
      >
        Free Form
      </button>
    </div>
  );
};

AspectRatioControls.propTypes = {
  activeAspectRatio: PropTypes.string.isRequired,
  setAspectRatio: PropTypes.func.isRequired
};

export default AspectRatioControls;
